import { createAutoGeneratedUserReq } from "Requests/User.req";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PackageJson from "../../package.json";

const Entry = () => {
  const navigate = useNavigate();

  const goToLoginPage = () => {
    navigate("/login");
  };

  const goToInitialNicknameSettingPage = () => {
    navigate("/initial-nickname");
  };

  return (
    <div className="entry page">
      <div className="logo">
        <div className="title">MIPS</div>
        <div className="subtitle">WEB 미니게임 플레이스테이션 v{PackageJson.version}</div>
      </div>
      <div className="main-btn-container">
        <button className="main-btn highlight" onClick={goToLoginPage}>
          로그인
        </button>
        <button className="main-btn" onClick={goToInitialNicknameSettingPage}>
          회원가입 없이 시작
        </button>
      </div>
    </div>
  );
};

export default Entry;
